<template>
  <donut-chart-card
    title="안전보건 예산 현황"
    :value="data"
    :total="total"
    unit="천원"
    :isMoveWrite="isMoveWrite"
    :is-move-detail="!!projectId"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
/* eslint-disable brace-style */
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart05',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 5,
      boardIds: [106, 154, 155], //106, 154, 155
      summaryKeys: {
        'detail' : ['안전보건예산_항목명', 'sum'],
        'field' : ['안전보건예산_사업장명', 'sum'],
        'field_cat1' : ['안전보건예산_사업장구분', 'sum'],
        'company' : ['안전보건예산_항목명', 'sum'],
        'project' : ['안전보건예산_항목명', 'sum'],
      },
      data: [{label: '데이터 없음', value: 0}],
      total: '0',
      cache: {},
    }
  },
  async mounted () {
    await this.loadDetailData();
    await this.loadGraph()
  },
  methods: {
    async loadDetailData(currentYear, depth) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      if (!depth) {
        depth = 1;
      }

      const cacheKey = `detail05_${currentYear}_${depth}`;
      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      } else {
        const allPosts = [];
        const conditions = [{key: 'header.year', operator: '=', value: new Date().getFullYear()}];
        for (let page = 1; page <= 1000; page++) {
          const response = await this.$store.dispatch("board/LOAD_POST_LIST", {
            projectId: this.projectId,
            boardId: 1034,
            page,
            perPage: 1000,
            conditions,
            withMeta: true,
            metaKeys: ['body.safetyBudgetList[%].편성유형', 'body.safetyBudgetList[%].예산'],
            onlyMeta: true,
          });
          allPosts.push(...response.data);
          if (response.last_page <= page) {
            break;
          }
        }
        console.log(allPosts);
        this.cache[cacheKey] = allPosts;
        return allPosts;
      }
    },
    async loadGraph () {
      const data = await this.loadDetailData()

      this.total = 0;
      const list = [];
      const graph2Data = {};
      if (!this.projectId) {
        // 프로젝트별로 집계
        for (const post of data) {
          const projectName = post.project.field_name || '기타';

          let safetyBudgetList = [];
          if (post.postContents && post.postContents.body && post.postContents.body.safetyBudgetList) {
            safetyBudgetList = post.postContents.body.safetyBudgetList;
          }

          for (const budget of safetyBudgetList) {
            if (!graph2Data[projectName]) {
              graph2Data[projectName] = 0;
            }
            graph2Data[projectName] += Number(budget.예산 ? budget.예산 : 0);
            this.total += Number(budget.예산 ? budget.예산 : 0);
          }
        }
      } else {
        for (const post of data) {
          let safetyBudgetList = [];
          if (post.postContents && post.postContents.body && post.postContents.body.safetyBudgetList) {
            safetyBudgetList = post.postContents.body.safetyBudgetList;
          }

          for (const budget of safetyBudgetList) {
            const 편성유형 = budget.편성유형 || '기타';
            if (!graph2Data[편성유형]) {
              graph2Data[편성유형] = 0;
            }
            graph2Data[편성유형] += Number(budget.예산 ? budget.예산 : 0);
            this.total += Number(budget.예산 ? budget.예산 : 0);
          }
        }
      }

      for (const key in graph2Data) {
        list.push({
          label: key,
          value: Number(graph2Data[key]),
        });
      }

      // list 데이터를 value에 따라서 내림차순 정렬한다
      list.sort((a, b) => {
        return b.value - a.value;
      });
      this.data = list;
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
